import { render } from "./UserEdite.vue?vue&type=template&id=2b524912&scoped=true"
import script from "./UserEdite.vue?vue&type=script&lang=js"
export * from "./UserEdite.vue?vue&type=script&lang=js"

import "./UserEdite.vue?vue&type=style&index=0&id=2b524912&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b524912"]])

export default __exports__